<template>
  <div class="ai-friend-app-stat">
    <ConfigTable
      ref="ct"
      :searchConfig="searchConfig"
      :tableColumns="tableColumns"
      :tableData="list"
      :total="total"
      @change="loadData"
    ></ConfigTable>
    <!-- <EditRoleTag ref="editDialog" @sure="callEdit"></EditRoleTag> -->
  </div>
</template>

<script>
import { changeDate } from "../../../utils/filter";
import ConfigTable from "@/components/config-table";
import aiFriendApi from "../../../api/aiFriendManage";
import { appOptions, getLabelTextWithValue } from "../../config";

const searchConfig = [
  { type: "select", placeholder: "选择App", key: "appId", options: appOptions },
  {
    type: "daterange",
    startPlaceholder: "选择开始日期",
    endPlaceholder: "选择结束日期",
    key: "startDate",
    keys: ["startDate", "endDate"],
  },
  { type: "button", icon: "search", placeholder: "搜索", key: "search" },
];

const tableColumns = [
  {
    name: "时间",
    key: "statTime",
    width: 160,
    valueHandler: changeDate,
    fixed: "fixed",
  },
  {
    name: "App",
    key: "appId",
    valueHandler: (val) => getLabelTextWithValue(appOptions, val),
  },
  { name: "总用户数", key: "totalUser" },
  { name: "创建对话次数", key: "createDialogs" },
  { name: "总消息数", key: "messages" },
  { name: "盈利$", key: "profitUsdt" },
  // { name: "变更后余额", key: "currentBalance" },
  { name: "提示词消耗积分", key: "promptAmount" },
  { name: "完成词消耗积分", key: "completionAmount" },
  { name: "总消耗积分", key: "amount" },
  { name: "提示词消耗USDT", key: "promptUsdt" },
  { name: "完成词消耗USDT", key: "completionUsdt" },
  { name: "总消耗USDT", key: "totalUsdt" },
  { name: "提示词成本USDT", key: "promptCost" },
  { name: "完成词成本USDT", key: "completionCost" },
  { name: "总成本USDT", key: "totalCost" },
  { name: "提示词Token数", key: "promptTokens" },
  { name: "完成词Token数", key: "completionTokens" },
  { name: "总Token数", key: "totalTokens" },
  {
    name: "创建时间",
    key: "createdAt",
    valueHandler: changeDate,
  },
];

export default {
  name: "AiFriendAppStat",
  components: { ConfigTable },
  data() {
    return {
      searchConfig,
      tableColumns,
      total: 0,
      list: [],
    };
  },
  watch: {},
  mounted() {},
  methods: {
    async loadData(params) {
      const ps = { ...params };
      try {
        const r = await aiFriendApi.getAppRealtime(ps);
        const data = r.data;
        this.total = data.total;
        this.list = data.list;
      } catch (error) {
        console.error("搜索ai角色标签失败：", error);
      }
    },
    add() {
      this.$refs.editDialog.open();
    },
    edit(row) {
      this.$refs.editDialog.open(row);
    },
    async deleteRow(row) {
      try {
        await this.$confirm("您确定要删除该条数据吗？", "操作提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        });
        await aiFriendApi.delAiRoleTag({ id: row.id });
        this.$message.success("已删除");
        this.$refs.ct.search();
      } catch (error) {
        console.log(error);
      }
    },
    async callEdit(r) {
      try {
        console.log(r);
        await (r.isEdit
          ? aiFriendApi.updateAiRoleTag(r.data)
          : aiFriendApi.createAiRoleTag(r.data));
        this.$message.success(r.isEdit ? "更新成功" : "新增成功");
        this.$refs.editDialog.close();
        setTimeout(() => {
          this.$refs.ct.search();
        }, 200);
      } catch (error) {
        console.error("call edit error:", error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ai-friend-app-stat {
  /deep/ .el-button {
    padding: 9px 15px;
  }

  /deep/ .el-image {
    width: 100px;
    height: 100px;

    img {
      object-fit: contain;
    }
  }
}
</style>
